import React from "react";
import UpSellWidgetCustomParent from "../components/UpSellWidgetCustomParent";
import { UpsellWidgetModelProvider } from "../hooks/useUpsellWidgetModelContext";
import useFileRequestPopupModel from "../hooks/UseFileRequestPopupModel";

export const UpsellPopupFileRequest = ({ fileId, setShowUpsell, downloadFileUrl }) => {
    const model = useFileRequestPopupModel(fileId, downloadFileUrl)
    return (
        <UpsellWidgetModelProvider model={model}>
            <UpSellWidgetCustomParent setShowUpsell={setShowUpsell} />
        </UpsellWidgetModelProvider>
    );
};